<template>
  <div class="transfer_detail">
    <Header :title="{name: '提现详情'}">
    </Header>
    <div class="content">
      <div class="amount">
        <p>提现金额</p>
        <p><i>￥</i>{{info.amount | toFixPrice}}</p>
      </div>
      <div class="info">
        <ul>
          <li>
            <span class="lable">提交时间：</span>
            <span class="value">{{info.create_at}}</span>
          </li>
          <li>
            <span class="lable">提现账户：</span>
            <span class="value">{{info.account_no}}</span>
          </li>
          <li>
            <span class="lable">真实姓名：</span>
            <span class="value">{{info.real_name}}</span>
          </li>
          <li>
            <span class="lable">提现金额：</span>
            <span class="value">￥{{info.amount/100}}</span>
          </li>
          <li>
            <span class="lable">审核状态：</span>
            <span class="value"
                  v-if="info.status==1">已通过</span>
            <span class="value"
                  v-if="info.status==2">未通过</span>
            <span class="value"
                  v-if="info.status==3">待审核</span>
          </li>
          <li>
            <span class="lable">审核时间：</span>
            <span class="value">{{info.audit_at}}</span>
          </li>
          <li>
            <span class="lable">审核原因：</span>
            <span class="value">{{info.remark}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  name: 'transfer_detail',
  components: {
    Header,
  },
  data () {
    return {
      info: {}
    }
  },
  created () {
    this.getTransferRecord();

  },
  methods: {
    getTransferRecord () {
      this.$http.post('/api/lector/teacher/account/transferRecord').then(data => {
        this.info = data.list[this.$route.query.index];
        console.log(this.info)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.transfer_detail {
  @extend %default-bg;
  background-color: #fff;
  font-family: PingFang SC;
  .content {
    padding: 0 30px;
    .amount {
      height: 200px;
      text-align: center;
      font-size: 30px;
      color: #333;
      padding-top: 66px;
      border-bottom: 1px solid #f6f6f6;
      p:nth-child(2) {
        margin-top: 34px;
        i {
          font-size: 60px;
        }
        font-size: 88px;
        font-weight: 600;
      }
    }
    .info {
      margin-top: 70px;
      font-size: 28px;
      color: #999;
      line-height: 50px;
      .value {
        color: #333;
      }
    }
  }
}
</style>